import React, { useEffect, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';
import { api } from '../lib/api';

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const parseIso = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
export const rentalEnd = (start, type, count) => {
    const d = parseIso(start);
    d.setDate(d.getDate() + (type === 'weekly' ? count * 7 : count) - 1);
    return iso(d);
};
export const overlaps = (booked, start, end) => booked.some((b) => b.start <= end && start <= b.end);

export const useAvailability = (machineId) => {
    const [booked, setBooked] = useState([]);
    useEffect(() => {
        setBooked([]);
        if (machineId) api.get(`/rentals/availability/${machineId}`).then((r) => setBooked(r.data.booked)).catch(() => {});
    }, [machineId]);
    return booked;
};

const RentalDatePicker = ({ value, onChange, booked, disabled }) => {
    const [open, setOpen] = useState(false);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const blocked = [{ before: today }, ...booked.map((b) => ({ from: parseIso(b.start), to: parseIso(b.end) }))];
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button type="button" disabled={disabled} data-testid="rental-start-date"
                    className="mt-1 w-full border border-neutral-300 bg-white px-3 py-2.5 text-left text-neutral-900 focus:outline-none focus:border-brand-primary disabled:opacity-50 flex items-center justify-between">
                    <span className={value ? '' : 'text-neutral-400'}>{value ? parseIso(value).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) : disabled ? 'Pick a machine first' : 'Pick a start date'}</span>
                    <CalendarDays className="h-4 w-4 text-neutral-500" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 bg-white text-neutral-900 border-neutral-300" align="start" data-testid="rental-calendar">
                <Calendar mode="single" selected={value ? parseIso(value) : undefined} defaultMonth={value ? parseIso(value) : today}
                    onSelect={(d) => { if (d) { onChange(iso(d)); setOpen(false); } }}
                    disabled={blocked} modifiers={{ booked: blocked.slice(1) }}
                    modifiersClassNames={{ booked: 'line-through text-red-400 bg-red-50' }} />
                <div className="px-3 pb-3 text-xs text-neutral-500 flex items-center gap-2">
                    <span className="inline-block w-3 h-3 bg-red-50 border border-red-200" /> Already booked
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default RentalDatePicker;
